import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {DcpPriceRatePlansData} from '@app/model/price/dcp-price-rate-plans-data';
import {
  DcpRatePlanService,
  RATE_PLAN_TYPE_NEW,
  RATE_PLAN_TYPE_TERMINATION
} from '@app/services/pricing/dcp-rate-plan.service';
import {combineLatest} from 'rxjs';
import {DcpCurrencyService} from '@app/services/pricing/dcp-currency.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

const ALL_CURRENCY: string = 'ALL';

@UntilDestroy()
@Component({
  selector: 'dcp-partner-plans-and-pricing-tooltip',
  templateUrl: './plans-and-pricing-tooltip.component.html',
  styleUrls: ['./plans-and-pricing-tooltip.component.scss']
})
export class PlansAndPricingTooltipComponent implements OnInit {

  ratePlan: DcpPriceRatePlansData;
  terminationRatePlanByCurrency: DcpPriceRatePlansData;
  terminationRatePlanCommon: DcpPriceRatePlansData;
  private currentCurrency: string;
  private newRatePlans: DcpPriceRatePlansData[];
  private terminationRatePlans: DcpPriceRatePlansData[];
  private _ratePlans: DcpPriceRatePlansData[];

  constructor(
    private ratePlanService: DcpRatePlanService,
    private currencyService: DcpCurrencyService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
  }

  @Input() set ratePlans(value: DcpPriceRatePlansData[]) {
    this._ratePlans = value;
    this.newRatePlans = this.ratePlanService.filterRatePlansByType(value, RATE_PLAN_TYPE_NEW);
    this.terminationRatePlans = this.ratePlanService.filterRatePlansByType(value, RATE_PLAN_TYPE_TERMINATION);
    this.prepareRatePlans();
  }

  get ratePlans(): DcpPriceRatePlansData[] {
    return this._ratePlans;
  }

  ngOnInit(): void {
    combineLatest([
      this.currencyService.getActive(),
      this.currencyService.getCurrencies()
    ]).pipe(untilDestroyed(this)).subscribe(([defaultCurrency, currencies]) => {
      this.currentCurrency = this.ratePlanService.selectRatePlanCurrency(this.ratePlans, defaultCurrency, currencies);
      this.prepareRatePlans();
      this.changeDetectorRef.detectChanges();
    });
  }

  prepareRatePlans() {
    this.ratePlan = this.ratePlanService.selectRatePlanByCurrency(this.newRatePlans, this.currentCurrency);
    this.terminationRatePlanByCurrency = this.ratePlanService.selectRatePlanByCurrency(this.terminationRatePlans, this.currentCurrency);
    this.terminationRatePlanCommon = this.ratePlanService.selectRatePlanByCurrency(this.terminationRatePlans, ALL_CURRENCY);
  }
}
